export default "__VITE_ASSET__b2777d49__"